











import { Prop, Component, Vue } from "vue-property-decorator";
import ProjectMember from "@/models/project-member";

@Component({})
export default class ProjectMemberOne extends Vue {
  @Prop({ required: true }) member!: ProjectMember;

  get icon() {
    return this.member.user.icon.imageURL;
  }

  get name() {
    if (this.member.staff) {
      return this.member.staff.name;
    }
    return "";
  }

  get companyName() {
    if (this.member.staff && (this.member.staff as any).company) {
      return (this.member.staff as any).company.name;
    }
    return "";
  }
}
